export enum ScrollbarPosition {
    Top,
    Mid,
    Bottom,
    None
}